import { UserTicketsModel } from '../../types/loginTypes';
import { UserVirtualOfficeLicence } from '../Settings/settings.types';

export interface Payment {
  amount: string;
  currencyType: number;
  dateCreated: string; // ISO date string
}

export interface MyOrderListModel {
  price: number;
  payments: Payment[];
  amountToPay: number;
  name: string;
  type: number;
  orderId: number;
  status: number;
  dateCreated: string; // ISO date string
  datePaid: string | null; // Nullable ISO date string
  currencyType: number;
  networkType: number;
  paymentAddress: string;
  currencyAmountToPay: string;
}

export interface GetMyPackageInfoResponse {
  orders: MyOrderListModel[];
}

export interface PackageModel {
  benefits: any;
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
  tickets: string | number;
  subtitle2: string;
}

export interface GetPackagesResponse {
  packages: PackageModel[];
}

export interface UserPackageModel {
  id: number;
  price: number;
  shoppingPoints: number;
  donationPoints: number;
  teamBonusPercent: number;
  status: number;
  dateCreated: string;
  datePaid: string;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: string;
  depositedUsdtAmount?: number;
  depositedCurrencyAmount?: number;
  depositedTokenCurrency?: string;
  mintedAmount?: number;
  mintedTokenCurrency?: string;
  isActive?: boolean;

  package: {
    packageId: number;
    name: string;
    title?: string;
    price: number;
    teamBonusPercent: number;
    order: number;
    stakeRatio: number;
    weekCapRuleLimit: number;
    volumePoints: number;
    type: number;
    maxDepositAmount?: number;
  };
  packageRank: {
    packageRankId: number;
    name: string;
  };
  nextPackageRank: {
    packageRankId: number;
    name: string;
  };
}

export interface Subscription {
  id: number;
  price: number;
  status: number;
  dateCreated: string; // ISO string format for dates
  dateEnd: string | null;
  datePaid: string | null;
  networkType: number;
  paymentAddress: string;
  currencyType: number;
  networkCurrencyType: number;
}

export interface AddPackageForUserResponse {
  userPackage: UserPackageModel;
  userTickets: UserTicketsModel;
  userVirtualOfficeLicence: UserVirtualOfficeLicence | null;
  subscription?: Subscription | null;
}

export interface MergedPackageModel extends PackageModel {
  id: number;
  image: string;
  title: string;
  price: number;
  weeklyCap: string;
  orderPlan: string;
  ranking: string;
  benefits: Benefit[];
  bonuses: Bonus[];
  firstGift: string;
  proRankBoost: number;
  calculator: string;
  limitedQuantity: boolean;

  dobuleTradingBinaries: number | string;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface TradingPackageModel {
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
  image: string;
  dobuleTradingBinaries: number | string;
  membershipBenefits: string[];
  extraTools: string[];
}

export interface BigWhalePackageModel {
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number | null;
  volumePoints: number;
  type: number;
  isPromo: boolean;
  image: string;
  benefits: string[];
}

interface Benefit {
  icon: number;
  text: string;
}

interface Bonus {
  icon: number;
  text: string;
}

export enum PurchaseSteps {
  INITIAL = 1,
  PAYMENT_METHOD,
  PAY_MIXED,
  PAY_TETHER,
  SUCCESS
}

export enum Tokens {
  TETHER,
  USDC
}

export enum TokenCurrencyType {
  TETHER = 1,
  USDC = 7
}
